import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import axios from 'axios';
import moment from 'moment';
import { endpoints, BaseUrl } from 'utils/factory';
import DeliveryListToolbar from '../components/customer/DeliveryListToolbar';
import DeliveryListTable from '../components/customer/DeliveryListTable';


const DeliveryList = () => {
  const [invoicelist, setInvoicelist] = useState([]);
  const [invoicelistOld, setInvoicelistOld] = useState([]);
  const [changeflag, setChangeFlag] = useState(false);
  const [bookedfilter, setBookedfilter] = useState(2);
  const [statusfilter, setStatusfilter] = useState(0);
  const [fromdate, setFromdate] = useState();
  const [todate, setTodate] = useState();
  const [loaderflag, setLoaderFlag] = useState(false);
  const [exportflag, setExportFlag] = useState(true);
  const [exportflagver, setExportFlagVer2] = useState(true);
  const [exportflagverCSV, setExportFlagVerCsv] = useState(true);

  const [invoicelistexport, setInvoicelistexport] = useState([]);
  const [invoicelistexportver, setInvoicelistexportver] = useState([]);
  const [invoicelistexportcsv, setInvoicelistexportcsv] = useState([]);

  const [searchtext, setSearchText] = useState('');

  const clientid = localStorage.getItem('trans-userId');
  const clientName = localStorage.getItem('trans-userName');
  const cmp_id = localStorage.getItem('trans-cmp_id');

  // Fetch Orders from API
  const fetchOrders = async (payload) => {
    setLoaderFlag(true);
    try {
      const response = await axios.post(`${BaseUrl}${endpoints.getOrdersInvoices}`, payload);
      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setInvoicelist(data);
        setInvoicelistOld(data);
      } else {
        setInvoicelist([]);
        setInvoicelistOld([]);
      }
    } catch (error) {
      console.error('API error', error);
    } finally {
      setLoaderFlag(false);
    }
  };

  // Handle Export Data
  const handleExportData = async () => {
    setLoaderFlag(true);
    const payload = {
      userid: clientid,
      qtype: '8',
      searchtext: bookedfilter,
      fdate: fromdate,
      tdate: todate,
    };

    try {
      const response = await axios.post(`${BaseUrl}${endpoints.getOrdersInvoices}`, payload);

      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        setInvoicelistexport(data);
        setExportFlag(false);
      } else {
        setInvoicelistexport([]);
        setExportFlag(false);
      }
    } catch (error) {
      console.error('API error', error);
    } finally {
      setLoaderFlag(false);
    }
  };

  // Handle Beta Version Two Export
  const handleBetaVersionTwo = async () => {
    setLoaderFlag(true);
    const payload = {
      userid: clientid,
      "invoiceno": searchtext,
      "delfrom": fromdate,
      "delto": todate,
      "bookingSts": bookedfilter,
      "qtype": "2",
      "deliverycompany": clientid,
      "itemStatusid": 1,
      "cmp_id": cmp_id
    };

    try {
      const response = await axios.post(`${BaseUrl}${endpoints.exportToExcel}`, payload);

      const data = response.data;
      console.log(data);
      if (Array.isArray(data) && data.length > 0) {
        setInvoicelistexportver(data);
        setExportFlagVer2(false);
      } else {
        setInvoicelistexportver([]);
        setExportFlagVer2(true);
      }
    } catch (error) {
      console.error('API error', error);
    } finally {
      setLoaderFlag(false);
    }
  };

  // Handle CSV Export
  const handleCsvButton = async () => {
    setLoaderFlag(true);
    const payload = {
      userid: clientid,
      "invoiceno": searchtext,
      "delfrom": fromdate,
      "delto": todate,
      "bookingSts": bookedfilter,
      "qtype": "1",
      "deliverycompany": clientid,
      "itemStatusid": 1,
      "cmp_id": cmp_id
    };

    try {
      const response = await axios.post(`${BaseUrl}${endpoints.exportToExcel}`, payload);

      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        if (clientid != 2) {
          setInvoicelistexportcsv(data);
        } else {
          const transformedData = data.map((item) => ({
            InvoiceID: item.InvoiceID,
            GoodsSummary: item.GoodsSummary,
            Qty: item.Qty,
            ItemWeight: item.ItemWeight,
            NumberofBoxes: item.NumberofBoxes,
            CBM: item.CBM,
            Source: item.Source,
            DeliveryType: item.DeliveryType,
            Deluxe: item.Deluxe,
            CustomerName: item.CustomerName,
            Street: item.Street,
            Suburb: item.Suburb,
            Postcode: item.Postcode,
            CustomerState: item.CustomerState,
            CustomerEmail: item.CustomerEmail,
            DeliveryComment: item.DeliveryComment,
            DeliveryCharges: item.DeliveryCharges,
            PrimaryNumber: item.CustomerPhone || "",
            SecondaryNumber: item.Comment || "",
          }));

          setInvoicelistexportcsv(transformedData);
        }
        setExportFlagVerCsv(false);
      } else {
        setInvoicelistexportcsv([]);
        setExportFlagVerCsv(false);
      }
    } catch (error) {
      console.error('API error', error);
    } finally {
      setLoaderFlag(false);
    }
  };

  // Reset Filters
  const handleResetFilter = () => {
    setBookedfilter(2);
    setStatusfilter(0);
  };

  // Handle Date Selection and Fetch Data
  const handleDate = (fdate, sdate, bfilter) => {
    setExportFlagVer2(true);
    setExportFlagVerCsv(true);
    const fdateformat = fdate ? moment.utc(fdate).format("YYYY-MM-DD") : moment.utc().format("YYYY-MM-DD");
    const sdateformat = sdate ? moment.utc(sdate).format("YYYY-MM-DD") : moment.utc().format("YYYY-MM-DD");


    setFromdate(fdateformat);
    setTodate(sdateformat);
    setBookedfilter(bfilter);

    if (fdateformat && sdateformat) {
      setChangeFlag(true);
      setLoaderFlag(true);
      setInvoicelist([]);
      setInvoicelistOld([]);

      const payload = {
        userid: clientid,
        qtype: '3',
        searchtext: "",
        Del_Datefrom: fdateformat,
        Del_Dateto: sdateformat,
        cmp_id: cmp_id,
        delsno: 0,
        username: clientName,
        bookingstatus: bfilter
      };

      fetchOrders(payload);
    }
  };

  // Handle Search
  const handleSearch = async (e, type) => {
    console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!1")
    if (e.code === 'Enter' || type === '2') {
      if (type === '2' && e === '') {
        handleDate(fromdate, todate, bookedfilter);
        return;
      }
      if (type === '1' && e.target.value === '') return;

      setChangeFlag(true);
      setExportFlagVer2(true);
      setExportFlagVerCsv(true);
      setLoaderFlag(true);
      handleResetFilter();

      const searchValue = type === '1' ? e.target.value : e;
      setSearchText(searchValue);

      console.log("wdddddddddddddddddddddddddddddddddd")
      const payload = {
        searchtext: searchValue,
        userid: clientid,
        Del_Datefrom: '',
        Del_Dateto: '',
        cmp_id: cmp_id,
        delsno: 0,
        username: clientName,
        bookingstatus: '',
        qtype: "1"
      };

      try {
        setInvoicelist([]);
        setInvoicelistOld([]);

        const response = await axios.post(`${BaseUrl}${endpoints.getOrdersInvoices}`, payload);

        const data = response.data;
        if (Array.isArray(data) && data.length > 0) {
          setInvoicelist(data);
          setInvoicelistOld(data);
        } else {
          setInvoicelist([]);
          setInvoicelistOld([]);
        }
      } catch (error) {
        console.error('API error', error);
      } finally {
        setLoaderFlag(false);
      }
    }
  };

  // Handle Child Data Update
  const getchilddata = (data) => {
    setInvoicelist(data);
    setInvoicelistOld(data);
  };

  // Handle Select Change for Filters
  const handleChangeSelectSearch = (invoicestatus, bookedstatus) => {
    setExportFlagVer2(true);
    setExportFlagVerCsv(true);
    let filteredData = invoicelistOld;

    if (bookedstatus === 0) {
      filteredData = invoicelistOld.filter(
        (item) => item.Itd_IsTransBooked === 'Pending'
      );
    } else if (bookedstatus === 1) {
      filteredData = invoicelistOld.filter(
        (item) => item.Itd_IsTransBooked === 'Booked'
      );
    } else if (invoicestatus === 0 && bookedstatus === 2) {
      filteredData = invoicelistOld;
    }

    if (invoicestatus === 1) {
      filteredData = filteredData.filter(
        (item) => item.Invoicestatus === 'Initiated'
      );
    } else if (invoicestatus === 2) {
      filteredData = filteredData.filter(
        (item) => item.Invoicestatus === 'Assign For Picking'
      );
    } else if (invoicestatus === 3) {
      filteredData = filteredData.filter(
        (item) => item.Invoicestatus === 'Picked'
      );
    } else if (invoicestatus === 4) {
      filteredData = filteredData.filter(
        (item) => item.Invoicestatus === 'Area Assign'
      );
    } else if (invoicestatus === 5) {
      filteredData = filteredData.filter(
        (item) => item.Invoicestatus === 'Ready for dispatch'
      );
    } else if (invoicestatus === 0 && bookedstatus === 2) {
      filteredData = invoicelistOld;
    }

    console.log("ssssssssssssssssss", filteredData)
    setInvoicelist(filteredData);
  };

  // Handle Select Change Event
  const handleChangeselect = (event) => {
    handleChangeSelectSearch(statusfilter, event.target.value);
    setBookedfilter(event.target.value);
  };

  // Initialize Date Filters on Component Mount
  useEffect(() => {
    const currentDate = moment().format('MM/DD/YYYY');
    const previousDate = moment().subtract(1, 'days').format('MM/DD/YYYY');
    setFromdate(moment(previousDate).format('YYYY-MM-DD'));
    setTodate(moment(currentDate).format('YYYY-MM-DD'));
    handleDate(previousDate, currentDate, 2);
  }, []);

  // Handle Search Text Update
  const handleSearchText = (inv) => {
    setSearchText(inv);
  };

  return (
    <>
      <Helmet>
        <title>Invoice List</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <DeliveryListToolbar
            clickToSearch={handleSearch}
            handleSearchText={handleSearchText}
            datesearch={handleDate}
            customers={invoicelist}
            handleChangeselect={handleChangeselect}
            selectvalue={bookedfilter}
            fromdate={fromdate}
            todate={todate}
            handleresetfilter={handleResetFilter}
          />
          <Box sx={{ pt: 3 }}>
            <DeliveryListTable
              customers={invoicelist}
              flagstatus={changeflag}
              getchilddata={getchilddata}
              fromdate={fromdate}
              todate={todate}
              datesearch={handleDate}
              bookedfilter={bookedfilter}
              loaderflag={loaderflag}
              exportlist={invoicelistexport}
              handleExportGrid={handleExportData}
              exportflag={exportflag}
              handleExportGridTwo={handleBetaVersionTwo}
              exportlisttwo={invoicelistexportver}
              exportflagver={exportflagver}
              exportflagverCSV={exportflagverCSV}
              handelCsvButon={handleCsvButton}
              invoicelistexportcsv={invoicelistexportcsv}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default DeliveryList;
